// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemCount-module--wrapper--35RoE","count":"ItemCount-module--count--1vS61"};